function n(n){return null===n}export{n as default};
//# sourceMappingURL=isNull.js.map
